import { createAction } from '../../../utils/helpers';
import * as actionTypes from './types';

export const fetchToursAggregate = createAction(actionTypes.FETCH_TOURS_AGGREGATE);
export const fetchToursAggregateInit = createAction(actionTypes.FETCH_TOURS_AGGREGATE_INIT);
export const fetchToursAggregateSuccess = createAction(actionTypes.FETCH_TOURS_AGGREGATE_SUCCESS);
export const fetchSaleOptionsInit = createAction(actionTypes.FETCH_SALE_OPTIONS_INIT);
export const fetchSaleOptionsSuccess = createAction(actionTypes.FETCH_SALE_OPTIONS_SUCCESS);
